/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { Market } from 'src/config';
import copy from 'src/config/medicaid/copy';
import asset from 'src/config/medicaid/asset';
import featureFlags from 'src/config/medicaid/featureFlags';

export const createMedicaidMarket = (): Market => {
  return { marketId: 'medicaid', copy: copy(), asset, featureFlags };
};
